import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useBlocker } from 'react-router-dom'
import { noop } from 'lodash'

import ConfirmDialog from '../confirm-dialog/ConfirmDialog'

const RouterPrompt = ({ when, onSubmitAction, ...props }) => {
  const navigate = useNavigate()
  const [isBlocking, setIsBlocking] = useState(false)
  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState('')

  useBlocker(({ location }) => {
    setCurrentPath(location.pathname)
    setShowPrompt(true)
    return props.question
  }, isBlocking)

  useEffect(() => {
    setIsBlocking(when)
  }, [when])

  useEffect(() => {
    if (!isBlocking && currentPath) {
      navigate(currentPath)
    }
  }, [isBlocking, currentPath])

  const handleSubmit = () => {
    setShowPrompt(false)
    setIsBlocking(false)
    onSubmitAction()
  }

  const handleCancel = () => {
    setShowPrompt(false)
    setCurrentPath('')
  }

  return <ConfirmDialog open={showPrompt} onClose={handleCancel} onSubmit={handleSubmit} {...props} />
}

RouterPrompt.propTypes = {
  when: PropTypes.bool,
  title: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onSubmitAction: PropTypes.func,
}

RouterPrompt.defaultProps = {
  when: false,
  confirmLabel: 'Yes',
  cancelLabel: 'Stay here',
  onSubmitAction: noop,
}

export default RouterPrompt
